/*
 * @Author: Fan
 * @Date: 2020-04-19 19:31:12
 * @description:
 * @LastEditors: Fu Zhuohang
 */
/*
 * @Author: Fan
 * @Date: 2020-04-18 21:23:13
 * @description:
 * @LastEditors: Fan
 */
import { DataType } from "../../../typings";
import { inputControlOptions, DateValueType, } from "../../../component-schema";
import i18n from "../../../i18n";
export default {
    $id: "calendar",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        defaultValue: {
            type: DataType.String,
            title: i18n.t('dataitem.DefaultValue').toString(),
            default: DateValueType.None,
        },
        dataItemDefault: {
            type: DataType.String,
            title: i18n.t('dataitem.DefaultValue2').toString(),
            default: "",
        },
        /**
         * 显示模式
         * 0 YYYY-MM-DD
         * 1 YYYY-MM-DD hh:mm
         * 2 YYYY-MM-DD hh:mm:ss
         */
        format1: {
            type: DataType.Integer,
            title: i18n.t('dataitem.Format1').toString(),
        },
        syncFormate: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.SyncDefaultFormat').toString(),
            default: true,
        },
        format: {
            type: DataType.Integer,
            title: i18n.t('dataitem.Format').toString(),
            default: "YYYY-MM-DD",
        },
        minDate: {
            type: DataType.String,
            title: i18n.t('dataitem.Minimum').toString(),
        },
        maxDate: {
            type: DataType.String,
            title: i18n.t('dataitem.Maximum').toString(),
        },
        verifyFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.SubmitValidation').toString(),
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
    },
};
